module.exports = __webpack_public_path__ + "static/img/yytx04.89dc30f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx04.png
// module id = 784
// module chunks = 0